const suspensionWidget = require('airship/widgets/suspensions')
const suspensionEl = document.querySelector('[rel=schedule-conversation]')

if (suspensionEl) {
  suspensionWidget(suspensionEl)
}
